import { FormInstance } from "antd";
import { useCallback } from "react";

export const useCompleteSecondStep = (
  form: FormInstance,
  selectedOption: string,
  gateway: any,
  saved: any,
  providerData: any,
  setRequest: React.Dispatch<React.SetStateAction<any>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
  setStep: React.Dispatch<React.SetStateAction<number>>,
) => {
  const onNext = useCallback(async () => {
    setRequest((prev: any) => ({
      ...prev,
      selectedMethodInfo: undefined,
      newMethod: undefined,
    }));

    setError(null);

    if (selectedOption === "1") {
      try {
        setIsLoading(true);
        await form.validateFields();
        gateway.submit();
      } catch {
        setIsLoading(false);
      }
    } else {
      const savedOption = saved.find((item: any) => item.id === selectedOption);

      if (savedOption) {
        setRequest((prev: any) => ({
          ...prev,
          selectedMethodInfo: savedOption,
          providerName: providerData.providerName,
        }));

        setStep(3);
      }
    }
  }, [
    gateway,
    saved,
    providerData,
    selectedOption,
    setRequest,
    setIsLoading,
    setError,
    setStep,
    form,
  ]);

  return { onNext };
};
